import { useEffect } from 'react';
import { WAITING_CALLS_PULSE_CLASS } from './callUiConstants';

export default function useWaitingCallsPulse(anchorEl, visibleCount) {
  useEffect(() => {
    if (!anchorEl) return undefined;

    if (visibleCount > 0) {
      anchorEl.classList.add(WAITING_CALLS_PULSE_CLASS);
    } else {
      anchorEl.classList.remove(WAITING_CALLS_PULSE_CLASS);
    }

    return () => {
      anchorEl.classList.remove(WAITING_CALLS_PULSE_CLASS);
    };
  }, [visibleCount, anchorEl]);
}
